module.exports = __webpack_public_path__ + "img/qrcode.c184c654.png";